<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        {
          name: 'Contact-Worldwide Offices List',
          to: {
            name: 'ContactPage'
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'OfficeEdit',
            params: {
              id: $route.params.id
            }
          }
        }
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>編輯Office Info</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <!--  -->
    <OfficeCreateEdit></OfficeCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import OfficeCreateEdit from '@/views/B-6__Contact/c/OfficeCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    OfficeCreateEdit,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('contact', ['contact']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getContact(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('contact', {
      getContact: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'ContactPage' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.save(this.contact).then(() => {
          this.$router.push({ name: 'ContactPage' });
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
